import { ApiHosts, handleResponseOld, makePost } from './helpers';
import { ItemDetail } from '@/types/item/ItemDetail';

/**
 * @category Item API
 * @see fetchItemDetailsByIds
 */
type FetchItemDetailsByIdsParams = {
    authToken?: string;
    deployment: string;
    itemIds: number[];
};

/**
 * @category Item API
 * @see fetchItemDetailsByIds
 */
type FetchItemDetailsByIdsResponse = {
    data: ItemDetail[];
    message: string;
    success: boolean;
};

/**
 * Fetches Item details by given itemIds via Post to Item API service
 * @function fetchItemDetailsByIds
 * @category Item API
 * @param {FetchItemDetailsByIdsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/item-detail
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-item-detail.ts
 */
const fetchItemDetailsByIds = ({ authToken, deployment, itemIds }: FetchItemDetailsByIdsParams) =>
    new Promise<FetchItemDetailsByIdsResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'spa/small/item-detail',
            authToken,
            deployment,
            path: ApiHosts.ItemApi,
        });
        request.send({ itemIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchItemDetailsByIds,
};
